interface PageHeroProps {
  title: string;
  subtitle?: string;
}

const PageHero = ({ title, subtitle }: PageHeroProps) => (
  <section className="bg-[#FFC300] py-16 md:py-20">
    <div className="container text-center max-w-3xl">
      <h1 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight tracking-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-5 text-lg text-[#1a1a1a]/80 font-medium leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
